export default function () {
  const options = {
    isEmpty: true,
  };

  if (options.isEmpty) {
    const moduleId = parseInt(document.getElementById('moduleId').value, 10);
    options.baseUrl = '/DesktopModules/RPS.MembershipApplication.Cex/API/';
    options.paymentsUrl = '/DesktopModules/Payment/API/';
    options.addressServiceUrl = '/DesktopModules/AddressService/API/';
    if (process.env.NODE_ENV === 'development') {
      options.headers = {
        ModuleId: process.env.VUE_APP_MODULE_ID,
        RequestVerificationToken: process.env.VUE_APP_RVT,
        TabId: process.env.VUE_APP_TAB_ID,
        'Content-Type': 'application/json',
      };
      options.isEmpty = false;
    } else {
      options.framework = window.$.ServicesFramework(moduleId);
      options.headers = {
        ModuleId: moduleId,
        RequestVerificationToken: options.framework.getAntiForgeryValue(),
        TabId: options.framework.getTabId(),
        'Content-Type': 'application/json',
      };
      options.isEmpty = false;
    }
  }
  return options;
}
